import React from 'react';
import { SelectedProductAttributes } from 'types/ProductPageV2/Products';
import ProductStickers, { Props } from './ProductStickers';

type ProductStickersAdapterProps = Omit<Props, 'stickers'> & {
  productAttributes: SelectedProductAttributes;
};

export default function ProductStickersAdapter({
  productAttributes,
  ...props
}: ProductStickersAdapterProps): JSX.Element | null {
  const stickers = {
    commercialOperation: productAttributes.stickerOpeco?.Value,
    principal: productAttributes.stickerPrincipal?.Value,
    secondary1: productAttributes.stickerSecondaire1?.Value,
    secondary2: productAttributes.stickerSecondaire2?.Value,
  };

  if (!Object.values(stickers).some(Boolean)) {
    return null;
  }

  return <ProductStickers stickers={stickers} {...props} />;
}
